import { render, staticRenderFns } from "./CsTarifariosTarifasTransporte.vue?vue&type=template&id=31204701"
import script from "./CsTarifariosTarifasTransporte.vue?vue&type=script&lang=js"
export * from "./CsTarifariosTarifasTransporte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports